import { RoomBaseApiService } from '@/core/service/room.baseapi.service'
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class UserService extends RoomBaseApiService {
    constructor() {
        super()
    }

    async changeProfileImage(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/users/profiles/images`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getUploadProfileImageSasUrl() {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/users/profiles/sas-url`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const userService = new UserService()